import {SET_COMMAND_INPUT} from 'constants/action-types.js';
import {SET_COMMAND_PREFIX} from 'constants/action-types.js';
import {SET_VI_MODE} from 'constants/action-types.js';

let initialState = {
    commandInput: undefined,
    commandPrefix: undefined,
    viMode: false,
};

const midiReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_COMMAND_INPUT:
        return {
            ... state,
            commandInput: action.payload
        };
    case SET_COMMAND_PREFIX:
        return {
            ... state,
            commandPrefix: action.payload
        };
    case SET_VI_MODE:
        return {
            ... state,
            viMode: action.payload
        };
    default:
        return state;
    }
}

export default midiReducer;
